import "babel-polyfill";

import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap-vue/dist/bootstrap-vue.js";

import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import "expose-loader?$!expose-loader?jQuery!jquery";

import VueSidebarMenu from "vue-sidebar-menu";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";
import "vue-sidebar-menu/dist/vue-sidebar-menu.js";
import "nprogress/nprogress.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import VueEvents from "vue-events";
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
import FilterBar from "@/components/FilterBar";
import ListingButtons from "@/components/ListingButtons";
import Textarea from "@/components/Textarea";
import Foot from "@/components/Foot";
import Head from "@/components/Head";
import MainNav from "@/components/MainNav";
import TopMenu from "@/components/TopMenu";
import EmergencyCta from "@/components/EmergencyCta";
import EmergencyCtaTall from "@/components/EmergencyCtaTall";

import ContentBlock from "@/components/ContentBlock";

// Centralised "Your Cart" widget. Registered globally so any page
// can drop in <CartWidget /> or <CartWidget standalone /> without
// a per-file import. The look-and-feel of the cart is owned by
// this single component — pages that mutate cart state (e.g.
// Search.vue's picker modal) still manage their own selectedParts
// arrays and pass them in via props.
import CartWidget from "@/components/Common/CartWidget";

// Centralised "Top 5 Most Purchased Parts" widget. Same shape as
// CartWidget above (controlled + standalone modes, owns its own
// collapsed-to-pill state and side-edge pill rendering) so the
// two widgets read as a coherent pair when both are visible on
// the same host. Registered globally for the same reason — any
// host page that wants the panel just drops <TopPartsWidget />
// or <TopPartsWidget standalone /> with no import boilerplate.
import TopPartsWidget from "@/components/Common/TopPartsWidget";

// Centralised "Important Information" widget. Third member of the
// floating right-edge widget family (CartWidget + TopPartsWidget) —
// owns its own collapsed-to-pill state and side-edge pill, and holds
// the CMS-driven service/banking notices that used to live inline on
// the Account dashboard. Registered globally so the single global
// mount in App.vue can show it on every authenticated portal page.
import ImportantInfoWidget from "@/components/Common/ImportantInfoWidget";

// "Guide" widget — fourth floating right-edge pill. Opens a modal that
// plays a captioned MP4 walkthrough of the portal. Registered globally so
// the single global mount in App.vue can show it on every authenticated
// portal page.
import HowItWorksWidget from "@/components/Common/HowItWorksWidget";

// Live interactive tour — drives the REAL page (spotlight + animated cursor +
// voiceover) and simulates the cart/order writes so nothing is ever ordered.
// Launched from the Guide chooser's "Live tour" via a root event.
import GuideTourWidget from "@/components/Common/GuideTourWidget";

// Admin authoring tool for the live tour — records voice + clicks + marked
// sections into a replayable tour (prototype: saved to localStorage).
import GuideTourRecorder from "@/components/Common/GuideTourRecorder";

// Admin tour BUILDER — type-to-voice + pick-to-highlight authoring with a
// live on-page preview (clearer than the live mic recorder).
import GuideTourBuilder from "@/components/Common/GuideTourBuilder";

// Account Setup audit widget — MASTER-only pill + modal showing how the
// selected company's account is configured. Registered globally for the
// single mount in App.vue.
import AccountSetupWidget from "@/components/Common/AccountSetupWidget";

import VueCurrencyInput from "vue-currency-input";
import VueTheMask from "vue-the-mask";

import VueAnalytics from 'vue-analytics';
import BlockUI from 'vue-blockui'

const pluginOptions = {
  globalOptions: {
    currency: "USD" // only override the default currency 'EUR' with 'USD'
  }
};
//Import Froala Editor 
import 'froala-editor/js/plugins.pkgd.min.js';
//Import third party plugins
import 'froala-editor/js/third_party/embedly.min';
import 'froala-editor/js/third_party/font_awesome.min';
// import 'froala-editor/js/third_party/spell_checker.min';
import 'froala-editor/js/third_party/image_tui.min';
// Import Froala Editor css files.
import 'froala-editor/css/froala_editor.pkgd.min.css';

// Import and use Vue Froala lib.
import VueFroala from 'vue-froala-wysiwyg'

import SuiVue from "semantic-ui-vue";

import "semantic-ui-transition/transition.js";
import "semantic-ui-css/semantic.min.css";
import "font-awesome/css/font-awesome.min.css";

// CSS files
import "@/assets/css/admin.less";
import "@/assets/css/normalize.less";
import "@/assets/css/variables.less";
import "@/assets/css/login.less";
import "@/assets/css/registration.less";
import "@/assets/css/frontend/header.less";
import "@/assets/css/frontend/footer.less";
import "@/assets/css/frontend/home.less";
import "@/assets/css/frontend/account.less";
import "@/assets/css/frontend/orders.less";
import "@/assets/css/frontend/cart.less";
import "@/assets/css/frontend/contact.less";
import "@/assets/css/frontend/informationcenter.less";
import "@/assets/css/frontend/faq.less";
import "@/assets/css/frontend/translate.less";

// Dark mode theme (v1 baseline). Toggled via the `dark-mode` class on
// <html> from the floating util-toggles stack in Head.vue. Class-based
// (not a CSS filter) so the many position:fixed floating widgets keep
// working. Imported last so its overrides win over the earlier sheets.
import "@/assets/css/frontend/darkmode.css";
// Mid-dark theme (steel-gray surfaces + black text). Toggled via the
// `mid-mode` class on <html> from the same util-toggles control in Head.vue.
import "@/assets/css/frontend/mid-mode.css";

import "@/assets/js/responsive.js";

// Apply the saved dark-mode preference BEFORE the app mounts so there's no
// flash of the light theme on a hard reload. Head.vue mirrors this into its
// toggle icon on mount.
try {
  var _colorMode = localStorage.getItem("colorMode");
  // Migrate the old boolean darkMode flag → the colorMode string.
  if (!_colorMode && localStorage.getItem("darkMode") === "1") _colorMode = "dark";
  // MID-DARK RETIRED (2026-07-26): the toggle is light ⇄ dark only. Anyone still holding
  // colorMode="mid" is migrated ONCE to dark (the nearer neighbour — mid was also a dark page
  // sheet) and the preference is REWRITTEN, otherwise they'd boot into a theme the toggle can no
  // longer reach. mid-mode.css stays imported and on disk; it is simply never activated now.
  if (_colorMode === "mid") {
    _colorMode = "dark";
    try { localStorage.colorMode = "dark"; localStorage.darkMode = "1"; } catch (e2) { /* noop */ }
  }
  if (_colorMode === "dark") {
    document.documentElement.classList.add("dark-mode");
  }
} catch (e) {
  // localStorage unavailable — skip; defaults to light.
}

// Email Insights "Quote this part" opens Search in a NEW TAB with the target customer company in the URL
// (switchCompanyId). Seed the active company SYNCHRONOUSLY here — before Vue / Head / Search mount — so the app
// renders with that customer already active: Search hydrates the part under the right company, and there's no
// late company switch that would reset the Search page. jcsCompanyHomed suppresses the NC999 session-home so it
// can't override this deliberate switch on the fresh tab.
try {
  var _qp = new URLSearchParams(window.location.search || "");
  var _switchCid = _qp.get("switchCompanyId");
  if (_switchCid) {
    localStorage.setItem("companyId", _switchCid);
    var _switchCode = _qp.get("switchCompanyCode");
    if (_switchCode) localStorage.setItem("companyCode", _switchCode);
    sessionStorage.setItem("jcsCompanyHomed", "1");
  }
} catch (e) {
  // no URL / storage — non-fatal.
}
// import config from '@/assets/js/appsettings.json';
// Vue.config.local = config;
Vue.config.productionTip = false;

library.add(faUserSecret);
Vue.component(library);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("filter-bar", FilterBar);
Vue.component("listing-buttons", ListingButtons);
Vue.component("Textarea", Textarea);
Vue.component("Head", Head);
Vue.component("MainNav", MainNav);
Vue.component("TopMenu", TopMenu);
Vue.component("Foot", Foot);
Vue.component("EmergencyCta", EmergencyCta);
Vue.component("EmergencyCtaTall", EmergencyCtaTall);

Vue.component("ContentBlock", ContentBlock);
Vue.component("CartWidget", CartWidget);
Vue.component("TopPartsWidget", TopPartsWidget);
Vue.component("ImportantInfoWidget", ImportantInfoWidget);
Vue.component("HowItWorksWidget", HowItWorksWidget);
Vue.component("GuideTourWidget", GuideTourWidget);
Vue.component("GuideTourRecorder", GuideTourRecorder);
Vue.component("GuideTourBuilder", GuideTourBuilder);
Vue.component("AccountSetupWidget", AccountSetupWidget);

Vue.use(VueCurrencyInput, pluginOptions);
Vue.use(VueTheMask);
Vue.use(SuiVue);

Vue.use(BootstrapVue);

Vue.use(VueSidebarMenu);
Vue.use(Vuetable);
Vue.use(VuetablePagination);
Vue.use(VuetablePaginationInfo);
Vue.use(VueEvents);
Vue.use(VueFroala);
Vue.use(BlockUI)

Vue.use(VueAnalytics, {
  id: 'UA-170668224-1',
  router
});

import PortalVue from "portal-vue";
Vue.use(PortalVue);

import { ToastPlugin } from "bootstrap-vue";
Vue.use(ToastPlugin);

Vue.use(require("vue-moment"));

import moment from "moment";
Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).format("MM/DD/YYYY hh:mma");
  }
});

new Vue({
  router,
  store,
  SuiVue,
  VueSidebarMenu,
  Head,
  MainNav,
  TopMenu,
  Foot,
  render: h => h(App)
}).$mount("#app");